import {
	OrderAdditionalServiceGdsServiceServiceType,
	OrderAdditionalServicesWithPredictionFragment,
	GdsServicesWithPurchasePredictionsFragment
} from '@websky/graphql';
import { CombinedSelectedServiceType } from './types';

export const getServicesWithPurchasePredictions = (
	services?: OrderAdditionalServicesWithPredictionFragment['additionalServices']
) => {
	return (services?.gdsServices?.services || []).filter(
		service =>
			!!service.aiPurchasePrediction &&
			[
				OrderAdditionalServiceGdsServiceServiceType.Baggage,
				OrderAdditionalServiceGdsServiceServiceType.Meal
			].includes(service.type)
	);
};

export const getServiceWithMaxPrediction = (
	services?: OrderAdditionalServicesWithPredictionFragment['additionalServices']
): GdsServicesWithPurchasePredictionsFragment => {
	const servicesWithPredictions = getServicesWithPurchasePredictions(services);

	if (!servicesWithPredictions.length) {
		return null;
	}

	return servicesWithPredictions.reduce((prev, current) => {
		return prev.aiPurchasePrediction?.[0]?.probability > current.aiPurchasePrediction?.[0]?.probability
			? prev
			: current;
	});
};

export const isGdsServiceType = (
	type: CombinedSelectedServiceType
): type is OrderAdditionalServiceGdsServiceServiceType => {
	return Object.values(OrderAdditionalServiceGdsServiceServiceType).includes(
		type as OrderAdditionalServiceGdsServiceServiceType
	);
};
